import { CompanyListModel } from 'services/EpdClient';
import { CollocationCenterModel } from 'types/types';
import { axiosInstance } from './apiCommon';

export const getCollocationCenters = async () => {
  return (await axiosInstance.get<CollocationCenterModel[]>(`/api/admin/v1/AdminCollocationCenters`)).data;
};

export const getCollocationCenterCompanies = async (id: string) => {
  return (await axiosInstance.get<CompanyListModel[]>(`/api/admin/v1/AdminCollocationCenters/${id}/companies`)).data;
};

export const deleteCollocationCenter = async (id: string) => {
  return await axiosInstance.delete(`/api/admin/v1/AdminCollocationCenters/${id}`);
};

export const createCollocationCenter = async (data: CollocationCenterModel) => {
  return await axiosInstance.post(`/api/admin/v1/AdminCollocationCenters`, data);
};

export const updateCollocationCenter = async (data: CollocationCenterModel) => {
  return await axiosInstance.put(`/api/admin/v1/AdminCollocationCenters/${data.id}`, data);
};

export const uploadCollocationCenterLogo = async (id: string, logo: File) => {
  const formData = new FormData();
  formData.append('logo', logo);
  return await axiosInstance.post(`/api/admin/v1/AdminCollocationCenters/${id}/upload-logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
